import React, { useState } from 'react'
import AddNewSexualOrientation from './AddNewSexualOrientation';

const SexualOrientation = ({ data, setIsRecordSaved, patientID, ...props }) => {
  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenSexualOrientation, setIsOpenSexualOrientation] = useState(false);
  const [sexualOrientationData, setSexualOrientationData] = useState([]);
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

  const AddSexualOrientation = (item) => {
    if(!isViewAllowed) return;
    setSexualOrientationData(item)
    setIsOpenSexualOrientation(prev => !prev);
  }
  const CloseSexualOrientation = () => {
    setIsOpenSexualOrientation(false)
  }

  let PopupScreen = "";
  if (isOpenSexualOrientation) {
    PopupScreen = <AddNewSexualOrientation isOpenSexualOrientation={isOpenSexualOrientation} sexualOrientationData={sexualOrientationData} setIsRecordSaved={setIsRecordSaved} onClose={CloseSexualOrientation} patientID={patientID} // onDeleteSexualOrientation={DeleteSexualOrientation} 
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  return (
    <div className='mx-2'>
      {PopupScreen}
      <div className="d-flex justify-content-between align-items-center mb-1">
        <p className='heading cursor-pointer user-select-none' onClick={handleToggleExpand}>Sexual Orientation</p>
        {data?.length > 0 ? null :
        <div className={`ar-add-icon ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddSexualOrientation({ PatientHistoryID: null })}>
          <i className="icon-dash-plus"></i>
        </div>}
      </div>
      <div className="d-flex flex-column gap-1">
        {expandItems &&
          (data?.length > 0 ?
          data.map(item => (
            <div className="d-flex justify-content-between align-items-center">
              <p className={`text validate-color font-m cursor-pointer ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddSexualOrientation(item)}>{item.SexualOrientation} </p>
            </div>)) :
          <p className="text C9-light-clr fst-italic">No sexual orientation recorded</p>)}
      </div>
    </div>
  )
}

export default SexualOrientation